module.exports = __webpack_public_path__ + "media/images/link_icon-16aca222.png";